import SectionView from '@/components/SectionView';
import prepareTranslate from '@/helpers/dictionary';
import { PROCESS_NOTIFICATION_SCREENS } from '@/helpers/enums';
import {
  Button,
  Center,
  Container,
  Flex,
  Text,
} from '@mantine/core';
import PropTypes from 'prop-types';

function DisplayAgent(props) {
  const {
    currentIdentifier,
    currentIdentifierSpot,
    setPage,
    clientOrAgreement,
    createdAgent,
    identifiers,
    fileTitle,
    onClose,
  } = props;

  const {
    company,
    product,
    identifierNumber,
    year,
    month,
  } = currentIdentifier;

  const t = prepareTranslate();

  let createAgreementButtonText;
  if (clientOrAgreement === PROCESS_NOTIFICATION_SCREENS.createAgreement) {
    createAgreementButtonText = t('components.processNotification.popUp.createAgreement');
  } else if (clientOrAgreement === PROCESS_NOTIFICATION_SCREENS.createClient) {
    createAgreementButtonText = t('components.processNotification.popUp.createClient');
  } else {
    createAgreementButtonText = t('components.processNotification.popUp.createAlternativeFund');
  }

  let clientOrAgreementInText;
  if (clientOrAgreement === PROCESS_NOTIFICATION_SCREENS.createAgreement) {
    clientOrAgreementInText = t('components.processNotification.popUp.agreements');
  } else if (clientOrAgreement === PROCESS_NOTIFICATION_SCREENS.createClient) {
    clientOrAgreementInText = t('components.processNotification.popUp.clients');
  } else {
    clientOrAgreementInText = t('components.processNotification.popUp.alternativeFunds');
  }

  const identifiersLength = identifiers.length;
  return (
    <Container fluid>
        <Text size='xs'>
          {`${identifiersLength} / ${currentIdentifierSpot}`}
      </Text>
      <Text c='var(--mantine-color-brand-5)' fw={'bold'} >{`בקובץ  ${fileTitle} מצאנו מספר ${clientOrAgreementInText} ${identifierNumber} שלא קיים במערכת`}</Text>
      <SectionView
        lines={[
          {
            title: 'חברה מנהלת',
            value: company.hebrew,
          },
          {
            title: 'מוצר',
            value: product.map((p) => p.hebrew).join(', '),
          },
          {
            title: 'חודש',
            value: month,
          },
          {
            title: 'שנה',
            value: year,
          },
        ]}
      />
      <Flex gap="lg" mt="xl" justify="space-between">
        <Flex gap="lg">
          <Button size="sm" onClick={() => setPage(1)} disabled={createdAgent}>
            {t('components.processNotification.popUp.createAgent')}
          </Button>
          <Button size="sm" variant="outline" onClick={() => setPage(clientOrAgreement)}>
            {createAgreementButtonText}
          </Button>
        </Flex>
        <Flex>
          <Button size="sm" variant="outline" onClick={onClose}>
            {t('components.processNotification.cancel')}
          </Button>
        </Flex>
      </Flex>
      <Center>
      </Center>
    </Container>
  );
}

DisplayAgent.propTypes = {
  currentIdentifier: PropTypes.shape({
    company: PropTypes.shape({
      hebrew: PropTypes.string.isRequired,
    }).isRequired,
    product: PropTypes.arrayOf(
      PropTypes.shape({
        hebrew: PropTypes.string.isRequired,
      }),
    ).isRequired,
    identifierNumber: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
    month: PropTypes.number.isRequired,
  }).isRequired,
  currentIdentifierSpot: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  clientOrAgreement: PropTypes.oneOf(Object.values(PROCESS_NOTIFICATION_SCREENS)).isRequired,
  createdAgent: PropTypes.any,
  identifiers: PropTypes.arrayOf(PropTypes.shape({
    company: PropTypes.shape({
      hebrew: PropTypes.string.isRequired,
    }).isRequired,
    product: PropTypes.shape({
      hebrew: PropTypes.string.isRequired,
    }).isRequired,
    identifierNumber: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
    month: PropTypes.number.isRequired,
  })).isRequired,
  fileTitle: PropTypes.string,
  onClose: PropTypes.func,

};

export default DisplayAgent;
